module.exports = __webpack_public_path__ + "images/bg-img-start_01f1a626158c3832d38597ddf0b47be4.png";